import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { createLLMCustomer } from "../graphql/mutations";
import {
  CreateLLMCustomerInput,
  CreateLLMCustomerMutation,
} from "../API";
import { v4 as uuidv4 } from "uuid";

export async function createLLMCustomerAfterEdit(
  values: CreateLLMCustomerInput
): Promise<GraphQLResult<CreateLLMCustomerMutation>> {
  return API.graphql(
    graphqlOperation(createLLMCustomer, {
      input: {
        id: values.projectId + uuidv4(),
        name: values.name,
        status: values.status,
        tokensRemaining: values.tokensRemaining,
        projectId: values.projectId,
        loadSheddingTier: values.loadSheddingTier,
        dataResidency: values.dataResidency,
        enterpriseUser: values.enterpriseUser ?? false,

        // Legacy fields
        tokenReplenishmentAmount:
          values.tokenReplenishmentAmount !== undefined
            ? values.tokenReplenishmentAmount
            : 0,
        tokenReplenishmentPeriod:
          values.tokenReplenishmentPeriod !== undefined
            ? values.tokenReplenishmentPeriod
            : undefined,

        usageTierId:
          values.usageTierId !== undefined ? values.usageTierId : undefined,

        lastCallMadeAt: new Date().toISOString(),
      },
    })
  ) as Promise<GraphQLResult<CreateLLMCustomerMutation>>;
}
